import { Immunization } from '@medplum/fhirtypes'

export const lastTouchedByPatient = (immunization: Immunization) => {
    // If there is no author, we assume the data was added by a service client and on behalf of the patient
    // In staging, the "www client" used to have a typo and it said "www cient" instead
    return /cl?ient$/gi.test(
        immunization?.meta?.author?.display?.trim() || 'Client'
    )
}
